import { Offer } from '@/interfaces/offer';
import { EntityResource } from './entity.resource';
import { OfferFilterVariables } from './queryVariables/filters/offer.filters';
import { OfferAcceptArgs, OfferAcceptVariables } from './queryVariables/offerAccept';

/**
 * Resource Wniosków
 *
 * @export
 * @class OfferResource
 * @extends {EntityResource<Offer>}
 */
export class OfferResource extends EntityResource<Offer> {
  public getFields = {
    id: true,
    content: true,
    created: true,
    modified: true,
    profile: {
      firstName: true,
      lastName: true,
      email: true
    },
    club: {
      id: true,
      name: true
    }
  };

  public listFields = {
    id: true,
    type: true,
    content: true,
    profile: {
      firstName: true,
      lastName: true
    },
    club: {
      id: true,
      name: true
    }
  };

  protected listVariables = OfferFilterVariables;

  constructor() {
    super({
      entityName: 'offer'
    });
  }

  /**
   * Akceptowanie wniosków
   *
   * @param {number} id
   * @param {number[]} teamIds
   * @returns {Promise<number>}
   * @memberof OfferResource
   */
  public async offerAccept(id: number, teamIds: number[]): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: OfferAcceptVariables,
        offerAccept: {
          __args: OfferAcceptArgs
        }
      }
    });
    return this.mutation(
      {
        mutation,
        variables: { id, teamIds }
      },
      'offerAccept'
    );
  }
}

export const offerResource = new OfferResource();
